import React, {Component} from 'react';
import {NavBar} from 'antd-mobile';
import './style.less';
const logo = require('../../../common/image/mintulogomin.png');
export default class Version extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    
    componentDidMount() {

    }

    render() {
        return (
            <div className="version">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}></i>}
                >版本说明</NavBar>
               <div className="image">
                    <img src={logo}/>
               </div>
               <div className="mintu">民途出行管理端</div>
               <div className="num">版本号：1.1.1</div>
               <div className="btn">检查更新</div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Member/Version/index.js